export const EmailStatus = {
  EMAIL_NOT_VALID: 'notValid',
  BLANK_EMAIL: 'blankEmail',
  CAN_NOT_FIND: 'canNotFind'
};

export const SignUpFields = {
  NAME: 'name',
  EMAIL: 'email',
  COMPANY: 'company',
  DOMAIN: 'domain',
  NUMBER: 'number'
};

export const SignUpErrors = {
  REQUIRED: 'required',
  INVALID_EMAIL: 'invalidEmail',
  INVALID_NUMBER: 'invalidNumber'
};

export const ResetPasswordErrors = {
  PASSWORD_REQUIRED: 'passwordRequired',
  CONFIRM_PASSWORD_REQUIRED: 'confirmPasswordRequired',
  DO_NOT_MATCH: 'notMatching'
};

export const SetNewPasswordErrors = {
  USERNAME_REQUIRED: 'passwordRequired',
  CURRENT_PASSWORD_REQUIRED: 'currentPasswordRequired',
  NEW_PASSWORD_REQUIRED: 'newPasswordRequired',
  CONFIRM_PASSWORD_DOES_NOT_MATCH: 'confirmPasswordDoesNotMatch'
};

export const ConfirmPasswordErrors = {
  USERNAME_REQUIRED: 'userNameRequired',
  PASSWORD_REQUIRED: 'passwordRequired',
  CODE_REQUIRED: 'codeRequired'
};

export const SupportErrors = {
  EMAIL_REQUIRED: 'emailRequired',
  MESSAGE_REQUIRED: 'messageRequired'
};
